import {
	useTranslationCommonUi,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Badge, Flex, Text } from '@mantine/core';
import { InvestmentSecurityRes } from '@dealstack/shared/lib/generated';
import { formatNumber } from '@dealstack/shared/lib/format/number';
import { extractDecimalPrecisionFromUnitDenominator } from '@dealstack/shared/lib/format/number.ts';

export const VestingSecuritySummary = ({
	securities,
	hideUnits,
	noSecuritiesText,
}: {
	securities?: InvestmentSecurityRes[];
	hideUnits?: boolean;
	noSecuritiesText?: string;
}) => {
	const tCommonUi = useTranslationCommonUi();
	const tMipManage = useTranslationMipManage();

	if (!securities?.length) {
		return (
			<Text fz="sm" fw={400} c="dark.0" mt=".5rem" fs="italic">
				{noSecuritiesText || tMipManage('vesting_terms_drawer.no_securities_text')}
			</Text>
		);
	}

	return (
		<Flex direction="column" gap="0.5rem">
			{securities.map((s) => {
				const minPrecision = extractDecimalPrecisionFromUnitDenominator(s.unitDenominator);
				const unitsText = hideUnits
					? ''
					: ` (${formatNumber({ value: s.units, lockPrecision: true, minPrecision })} ${tCommonUi('units')})`;
				return (
					<Flex gap="0.5rem" align="center" key={s.id}>
						<Text fz="lg" fw={400}>
							{s.name}
							{unitsText}
						</Text>
						{s.isSubjectToVesting && (
							<Badge variant="outline" size="xs" radius="sm">
								{tMipManage('vesting_terms_drawer.vesting_badge')}
							</Badge>
						)}
					</Flex>
				);
			})}
		</Flex>
	);
};
